import { Suspense, lazy, FC } from 'react';
import { useSelector } from 'react-redux';
import { useFragment, graphql } from 'react-relay';

// types
import { PdpSharedAuctionCountdownLazy_item$key as Item } from './__generated__/PdpSharedAuctionCountdownLazy_item.graphql';

// styles
import styles from './PdpSharedAuctionCountdown.scss';

const PdpSharedAuctionCountdown = lazy(
    () => import(/* webpackChunkName: "PdpSharedAuctionCountdown" */ './PdpSharedAuctionCountdown')
);

type Props = {
    item: Item;
    onCountdownFinished?: () => void;
};

type RelayVariables = {
    isClient: boolean;
};

type ReduxStoreType = {
    relayVariables: {
        variables: RelayVariables;
    };
};

const Spacer: FC = ({ children }) => <div className={styles.countdown}>{children}</div>;

const itemFragment = graphql`
    fragment PdpSharedAuctionCountdownLazy_item on Item {
        ...PdpSharedAuctionCountdown_item
    }
`;

export const PdpSharedAuctionCountdownLazy: FC<Props> = ({
    item: itemRef,
    onCountdownFinished,
}) => {
    const item = useFragment(itemFragment, itemRef);
    const { isClient } = useSelector<ReduxStoreType, RelayVariables>(
        relay => relay?.relayVariables?.variables || {}
    );

    if (!isClient) {
        return <Spacer />;
    }

    return (
        <Suspense fallback={<Spacer />}>
            <Spacer>
                <PdpSharedAuctionCountdown item={item} onCountdownFinished={onCountdownFinished} />
            </Spacer>
        </Suspense>
    );
};
